import React, { /* useEffect, */ useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { Button, ButtonBookmark, ButtonLike } from '../../../components'
import apiService from '../../../features/api/service'
import { errorHandler, useViewport } from '../../../utils'

const ActionButtons = ({ className }) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const { isMobile } = useViewport()
  const {
    total_likes,
    bookmarked: defaultBookmarked,
    liked: defaultLiked
  } = useSelector(state => state.organization.data)
  const [bookmarked, setBookmarked] = useState()
  const [liked, setLiked] = useState()
  const organization = useSelector(state => state.organizations.page_organization_detail_data)
  const { profile } = organization
  const organizationId = useSelector(state => state.organization.data.id)
  const { isVerified, isOfficial, isLoggedIn } = useSelector(state => state.account)
  const bookmarkable = isOfficial || isVerified ? true : false
  const likable = isLoggedIn

  // useEffect(() => {
  //   onChangeBookmark(bookmarked)
  //   //eslint-disable-next-line
  // }, [bookmarked])

  // useEffect(() => {
  //   onChangeLike(liked)
  //   //eslint-disable-next-line
  // }, [liked])

  useEffect(() => {
    setLiked(defaultLiked)
    setBookmarked(defaultBookmarked)
  }, [defaultLiked, defaultBookmarked])

  const handleBookmark = () => {
    const newState = !bookmarked
    console.log('bookmarked:', newState, organizationId)

    if(organizationId){
      const requestBody = newState ? {
        "bookmark": 1
      } : {
        "unbookmark": 1
      }

      apiService.update('organizations_update', organizationId, requestBody)
        .then((res) => {
          if(res.message){
            toast.success(res.message)
          } else {
            toast.success(newState ? 'Bookmarked!' : 'Unbookmarked!')
          }
          setBookmarked(newState)
        })
        .catch(err => {
          console.log(err)
          const msg = errorHandler(err)
          toast.error(msg ? msg : 'Failed.')
        })
    }
  }

  const handleLike = () => {
    const newState = !liked
    console.log('liked:', newState, organizationId)

    if(organizationId){
      const requestBody = newState ? {
        "like": 1
      } : {
        "unlike": 1
      }

      apiService.update('organizations_update', organizationId, requestBody)
        .then((res) => {
          if(res.message){
            toast.success(res.message)
          } else {
            toast.success(newState ? 'Liked!' : 'Unliked!')
          }
          setLiked(newState)
        })
        .catch(err => {
          console.log(err)
          const msg = errorHandler(err)
          toast.error(msg ? msg : 'Failed.')
        })
    }
  }

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = profile;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <div className={`${className}`}>
      <Button
        thin={isMobile}
        disabled={!profile}
        onClick={handleDownload}
      >
        {translation.BUTTON.download_profile[language.name]}
      </Button>
      {
        !isOfficial && <>
          <ButtonBookmark
            thin={true}
            className="mt-4 lg:mt-5"
            onClick={handleBookmark}
            active={bookmarked}
            disabled={!bookmarkable}
          />
          <ButtonLike
            thin={true}
            className="mt-4 lg:mt-5 mb-2"
            onClick={handleLike} active={liked}
            disabled={!likable}
          />
          <p className="text-xs text-gray-444 text-center">
            {translation.LIKE.liked_by[language.name]} {liked ? (total_likes+1) : total_likes}
          </p>
        </>
      }
    </div>
  )
}

export { ActionButtons }
